export enum ValveState {
	Open,
	Pending,
	Closed,
	Unknown
}